const getOpenDatabase = (): boolean => {
    return !!window.openDatabase
}

export default getOpenDatabase;